import React, { useState, useMemo } from "react";
import { useLoaderData, useSearchParams } from "react-router-dom";   // ⬅️ useSearchParams
import styled from "styled-components";
import { customFetch } from "../utils/custom-fetch";
import { toast } from "react-toastify";

/* ---------- loader ---------- */
export const loader = async () => {
  try {
    const { data } = await customFetch.get("/buildings");
    return { buildings: data.buildings };
  } catch (error) {
    console.error("Error loading buildings:", error);
    return { buildings: [] };
  }
};

/* ---------- component ---------- */
const ChooseScreenPage = () => {
  const { buildings } = useLoaderData();
  const [search]      = useSearchParams();         // ⬅️ קריאת הפרמטרים מה-URL

  const screenId     = search.get("screenId");
  const sessionToken = search.get("sessionToken");

  /* -------------------- סינון ערים/רחובות/בניינים -------------------- */
  const [selectedCity, setSelectedCity]       = useState(null);
  const [selectedStreet, setSelectedStreet]   = useState(null);

  const uniqueCities = useMemo(() =>
    [...new Set(buildings.map((b) => b.city))].sort((a, b) =>
      a.localeCompare(b, "he")
    ), [buildings]);

  const streetsInCity = useMemo(() => {
    if (!selectedCity) return [];
    return [...new Set(buildings
      .filter((b) => b.city === selectedCity)
      .map((b) => b.street)
    )].sort((a, b) => a.localeCompare(b, "he"));
  }, [selectedCity, buildings]);

  const buildingsInStreet = useMemo(() => {
    if (!selectedStreet) return [];
    return buildings
      .filter((b) => b.city === selectedCity && b.street === selectedStreet)
      .sort((a, b) => a.houseNumber - b.houseNumber);
  }, [selectedStreet, selectedCity, buildings]);

  /* -------------------- בחירת בניין -------------------- */
  const handleSelectBuilding = async (buildingId) => {
    if (!screenId || !sessionToken) {
      console.error("חסר screenId או sessionToken ב-URL");
      toast.error("חסרים פרטים לזיהוי המסך – נסה לסרוק מחדש");
      return;
    }

    try {
      const res = await customFetch.patch("/public/update-building-selection", {
        screenId,
        buildingId,
        sessionToken,
      });

      res.status === 200
        ? toast.success("בחירת הבניין עודכנה בהצלחה")
        : toast.error("שגיאה בעדכון בחירת הבניין");
    } catch (err) {
      console.error("שגיאה בטיפול בבחירת הבניין:", err);
      toast.error("שגיאה בעדכון בחירת הבניין");
    }
  };

  /* -------------------- UI -------------------- */
  return (
    <ScreenContainer>
      <Title>בחר בניין להצגה</Title>

      {!selectedCity && (
        <ListContainer>
          {uniqueCities.map((city) => (
            <ListItem key={city} onClick={() => setSelectedCity(city)}>
              {city}
            </ListItem>
          ))}
        </ListContainer>
      )}

      {selectedCity && !selectedStreet && (
        <ListContainer>
          <BackButton onClick={() => setSelectedCity(null)}>🔙 חזור לערים</BackButton>
          {streetsInCity.map((street) => (
            <ListItem key={street} onClick={() => setSelectedStreet(street)}>
              {street}
            </ListItem>
          ))}
        </ListContainer>
      )}

      {selectedStreet && (
        <ListContainer>
          <BackButton onClick={() => setSelectedStreet(null)}>🔙 חזור לרחובות</BackButton>
          {buildingsInStreet.map((b) => (
            <ListItem key={b._id} onClick={() => handleSelectBuilding(b._id)}>
              {b.street} {b.houseNumber}
            </ListItem>
          ))}
        </ListContainer>
      )}
    </ScreenContainer>
  );
};

/* ---------- styled-components ---------- */
const ScreenContainer = styled.div`
  text-align: center;
  padding: 20px;
  height: 100vh;
`;

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 20px;
`;

const ListContainer = styled.ul`
  list-style-type: none;
  padding: 0;
  max-width: 400px;
  margin: 0 auto;
`;

const ListItem = styled.li`
  padding: 15px;
  margin: 10px 0;
  background-color: #e0e0e0;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
  &:hover { background-color: #c0c0c0; }
`;

const BackButton = styled.button`
  background: none;
  border: none;
  color: blue;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 10px;
  &:hover { text-decoration: underline; }
`;

export default ChooseScreenPage;

